<template>
  <div>
    <v-card class="rounded-lg" flat>
      <v-card-title class="px-10 pt-8">
        <p>{{ $t("organization.config_recurrences.title") }}</p>
      </v-card-title>
      <v-divider />
      <v-card-text class="pl-8">
        <v-row v-if="payload.status">
          <v-col cols="12">
            <v-row dense>
              <v-col cols="12">
                <h2 style="display: inline">
                  {{ $t("organization.config_recurrences.retry.title") }}
                </h2>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="primary"
                      dark
                      v-bind="attrs"
                      size="22"
                      v-on="on"
                      style="transform: translateY(-2px)"
                    >
                      help_outlined
                    </v-icon>
                  </template>
                  <span>{{
                    $t(
                      "organization.config_recurrences.retry_days_in_month.tooltip"
                    )
                  }}</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" class="pl-2 pt-4">
                <v-row
                  dense
                  style="display: flex; align-items: center; gap: 1rem"
                >
                  <h3>
                    {{
                      $t(
                        "organization.config_recurrences.retry_days_in_month.text"
                      )
                    }}
                  </h3>
                  <div>
                    <v-select
                      v-model="payload.json_config.retry_days_in_month"
                      :items="new Array(10).fill(0).map((_, i) => i + 1)"
                      hide-details
                      dense
                      outlined
                      class="select"
                    >
                      <template v-slot:item="{ item, on, attrs }">
                        <v-list-item
                          :v-bind="attrs"
                          v-on="on"
                          :disabled="isAllowedRetryPerMonth(item)"
                        >
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ item }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-select>
                  </div>
                  <h3>
                    {{ $t("organization.config_recurrences.per_month") }}
                  </h3>
                </v-row>
              </v-col>
              <v-col cols="12" class="pl-2 mt-4">
                <v-row
                  dense
                  style="display: flex; align-items: center; gap: 1rem"
                >
                  <h3>
                    {{
                      $t(
                        "organization.config_recurrences.retry_days_between_dates.text"
                      )
                    }}
                  </h3>

                  <div>
                    <v-select
                      v-model="payload.json_config.retry_days_between_dates"
                      :items="new Array(6).fill(0).map((_, i) => i)"
                      hide-details
                      dense
                      outlined
                      class="select"
                      @change="handleRetryDaysInMonth"
                    >
                      <template v-slot:item="{ item, on, attrs }">
                        <v-list-item
                          :v-bind="attrs"
                          v-on="on"
                          :disabled="false"
                        >
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ item }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-select>
                  </div>
                  <h3>
                    {{ $t("organization.config_recurrences.times") }}
                  </h3>
                </v-row>
              </v-col>
            </v-row>
            <v-row dense class="pt-8">
              <v-col cols="12">
                <h2 style="display: inline">
                  {{ $t("organization.config_recurrences.payment_days.title") }}
                </h2>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="primary"
                      dark
                      v-bind="attrs"
                      size="22"
                      v-on="on"
                      style="transform: translateY(-2px)"
                    >
                      help_outlined
                    </v-icon>
                  </template>
                  <span>{{
                    $t(
                      "organization.config_recurrences.retry_days_in_month.tooltip"
                    )
                  }}</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12">
                <v-row dense>
                  <v-col cols="12">
                    <span>
                      {{
                        $t("organization.config_recurrences.payment_days.text")
                      }}
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-timeline dense>
                  <v-timeline-item
                    v-for="(item, i) in timeLineItems"
                    :key="i"
                    :color="item.color ? item.color : ''"
                    :icon="item.icon"
                    icon-color="black"
                    :style="
                      i === 0
                        ? 'background-color: #F2F4F7; border-radius: 10px; padding-top: 10px; padding-bottom: 10px;'
                        : 'padding-top: 10px;'
                    "
                  >
                    <div v-if="i === 0" class="py-4">
                      <h2>
                        {{
                          $t(
                            "organization.config_recurrences.payment_days.subscription"
                          )
                        }}
                      </h2>
                    </div>
                    <div
                      v-else
                      class="pb-8"
                      style="display: flex; gap: 1rem; align-items: center"
                    >
                      <h3 style="display: inline">
                        {{ mapPaymentDay(i) }}
                        {{
                          $t(
                            "organization.config_recurrences.payment_days.charge_text"
                          )
                        }}
                      </h3>
                      <div>
                        <v-select
                          v-model="payment_days[`day_${i}`]"
                          :items="
                            new Array(daysPicker).fill(0).map((_, i) => i + 1)
                          "
                          hide-details
                          dense
                          outlined
                          class="select-day"
                          :disabled="
                            i > 1 ? payment_days[`day_${i - 1}`] < 1 : false
                          "
                          @click="settingData = true"
                        >
                          <template v-slot:item="{ item, on, attrs }">
                            <v-list-item
                              :v-bind="attrs"
                              v-on="on"
                              :disabled="isAllowedPaymentDay(item, i)"
                            >
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{ item }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-select>
                        <span
                          v-if="
                            payload.json_config.retry_days_between_dates === 0
                          "
                          style="
                                  position: absolute;
                                  left: 5px;
                                  top: 50%;
                                  width: 200px;
                                  line-height: 16px;
                                "
                        >
                          {{
                            $t(
                              "organization.config_recurrences.payment_days.charge_helper_text.no_retry"
                            )
                          }}
                        </span>
                        <span
                          v-else-if="
                            !(payment_days[`day_${i}`] < 1) &&
                              payment_days[`day_${i}`] < 28
                          "
                          style="
                                  position: absolute;
                                  left: 5px;
                                  top: 50%;
                                  width: 200px;
                                  line-height: 16px;
                                "
                        >
                          {{
                            $t(
                              "organization.config_recurrences.payment_days.charge_helper_text.main"
                            )
                          }}
                          <b> {{ retryDaysMessage(i) }} </b>
                          {{
                            $t(
                              "organization.config_recurrences.payment_days.charge_helper_text.by_month"
                            )
                          }}
                        </span>
                        <span
                          v-else-if="payment_days[`day_${i}`] === 28"
                          style="
                                  position: absolute;
                                  left: 5px;
                                  top: 50%;
                                  width: 200px;
                                  line-height: 16px;
                                "
                        >
                          {{
                            $t(
                              "organization.config_recurrences.payment_days.charge_helper_text.last_day"
                            )
                          }}
                        </span>
                        <span
                          v-else
                          style="
                                  position: absolute;
                                  left: 5px;
                                  top: 50%;
                                  width: 200px;
                                  line-height: 16px;
                                "
                        >
                          {{
                            $t(
                              "organization.config_recurrences.payment_days.charge_helper_text.stand_by"
                            )
                          }}
                        </span>
                      </div>
                      <h3>
                        {{ $t("organization.config_recurrences.of_month") }}
                      </h3>
                      <v-btn
                        v-if="
                          i > 3 && Object.keys(timeLineItems).length === i + 1
                        "
                        @click="deleteNewDate(i)"
                        class="ml-12 px-2 py-5"
                        outlined
                        color="#B42318"
                      >
                        <v-icon> mdi-trash-can-outline </v-icon>
                        {{
                          $t(
                            "organization.config_recurrences.payment_days.delete"
                          )
                        }}
                      </v-btn>
                    </div>
                  </v-timeline-item>
                </v-timeline>
                <v-btn
                  @click="addNewDate"
                  outlined
                  class="px-2"
                  style="border: 1px dashed #d0d5dd"
                >
                  <v-icon> mdi-plus </v-icon>
                  {{ $t("organization.config_recurrences.payment_days.add") }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row dense class="pt-8">
              <v-col cols="12">
                <h2 style="display: inline">
                  {{ $t("organization.config_recurrences.retry_month.title") }}
                </h2>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="primary"
                      dark
                      v-bind="attrs"
                      size="22"
                      v-on="on"
                      style="transform: translateY(-2px)"
                    >
                      help_outlined
                    </v-icon>
                  </template>
                  <span>{{
                    $t("organization.config_recurrences.retry_month.tooltip")
                  }}</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" class="pl-2 pt-4">
                <v-row
                  dense
                  style="display: flex; align-items: center; gap: 1rem"
                >
                  <v-card class="px-2 py-2" style="border-radius: 100%;">
                    <v-icon color="black">credit_card</v-icon>
                  </v-card>
                  <h3>
                    {{ $t("organization.config_recurrences.retry_month.text") }}
                  </h3>

                  <div>
                    <v-select
                      v-model="payload.json_config.retry_month"
                      :items="new Array(12).fill(0).map((_, i) => i + 1)"
                      hide-details
                      dense
                      outlined
                      class="select"
                    >
                      <template v-slot:item="{ item, on, attrs }">
                        <v-list-item :v-bind="attrs" v-on="on">
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ item }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-select>
                  </div>
                  <h3>
                    {{ $t("organization.config_recurrences.month") }}
                  </h3>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="d-flex justify-end">
            <v-btn color="#2661FF" class="rounded-lg" @click="submit()">
              <span class="white--text">{{ $t("actions.save") }}</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-else class="d-flex justify-center align-center my-6">
          <v-card
            color="#EBF0FF"
            class="rounded-lg d-flex align-center pa-4"
            min-height="150"
            style="width: 90%; position: relative;"
            flat
          >
            <v-card-text class="d-flex justify-space-around align-center">
              <div
                class="subtitle-1 font-weight-regular text-center"
                style="color: #2661FF; max-width: 400px;"
              >
                {{ $t("organization.config_recurrences.info") }}
              </div>
              <div
                class="d-flex justify-space-around"
                style="gap: 15px; z-index: 10;"
              >
                <v-btn
                  class="pa-4 rounded-lg"
                  color="#2661FF"
                  large
                  @click="initModal = true"
                  ><span style="color: #fff;">{{
                    $t("actions.activate")
                  }}</span></v-btn
                >
              </div>
            </v-card-text>
          </v-card>
        </v-row>
      </v-card-text>
    </v-card>
    <BaseConfirmDialog
      v-if="initModal"
      :width="600"
      :title="$t('organization.config_recurrences.title_activate_modal')"
      :description="
        $t('organization.config_recurrences.description_activate_modal')
      "
      :accept-text="$t('actions.accept')"
      :cancel-text="$t('general.cancel')"
      @close="initModal = false"
      @proceed="submitInit()"
    />
    <BaseSuccessDialog
      :width="450"
      :value="successModal"
      :text="$t('organization.config_recurrences.text_success_modal')"
      :buttonText="$t('actions.accept')"
      @close="successModal = false"
    />
  </div>
</template>

<script>
/* eslint-disable object-curly-newline */
// eslint-disable-next-line import/no-extraneous-dependencies
import { mapState, mapActions } from "vuex";
import NumberSelector from "@/components/Common/NumberSelector";
import BaseConfirmDialog from "@/components/BaseConfirmDialog";
import BaseSuccessDialog from "@/components/BaseSuccessDialogV2";
import SelectDayPicker from "@/components/Common/SelectDayPicker";

export default {
  name: "RecurrencesServiceDrawer",
  components: {
    NumberSelector,
    BaseConfirmDialog,
    BaseSuccessDialog,
    SelectDayPicker
  },
  data: () => ({
    loading: false,
    initModal: false,
    successModal: false,
    settingData: false,
    payload: {
      addon_id: 2,
      json_config: {
        retry_days_in_month: 1,
        retry_days_between_dates: 1,
        retry_month: 1,
        day_1: 0,
        day_2: 0,
        day_3: 0,
        day_4: 0,
        day_5: 0,
        day_6: 0,
        day_7: 0
      },
      status: false
    },
    payment_days: {
      day_1: 0,
      day_2: 0,
      day_3: 0,
      day_4: 0,
      day_5: 0,
      day_6: 0,
      day_7: 0
    },
    daysPicker: 28,
    retryPerMonth_min: 0,
    retryPerMonth_max: 10,
    timeLineItems: [
      {
        color: "#F2F4F7",
        icon: "credit_score"
      },
      {
        icon: "credit_card"
      },
      {
        icon: "credit_card"
      },
      {
        icon: "credit_card"
      }
    ]
  }),
  computed: {
    ...mapState({
      organizationAddons: ({ organization: { organizationAddons } }) =>
        organizationAddons,
      orgId: ({ organization: { orgId } }) => orgId
    })

    // selectedDays () {
    //   const days = []
    //   const {
    //     json_config: {
    //       day_one,
    //       day_two,
    //       day_three,
    //       day_four,
    //       day_five,
    //       day_six,
    //       day_seven
    //     }
    //   } = this.payload
    //   if (day_one) {
    //     days.push(day_one)
    //   }
    //   if (day_two) {
    //     days.push(day_two)
    //   }
    //   if (day_three) {
    //     days.push(day_three)
    //   }
    //   if (day_four) {
    //     days.push(day_four)
    //   }
    //   if (day_five) {
    //     days.push(day_five)
    //   }
    //   return days
    // }
  },
  async mounted() {
    this.loading = true;
    this.setLocalData();
    this.loading = false;
  },
  watch: {
    "payment_days.day_1"() {
      if (!this.settingData) return;

      for (let i = 2; i <= 7; i++) {
        this.payment_days[`day_${i}`] = 0;
      }
    },
    "payment_days.day_2"() {
      if (!this.settingData) return;
      const { day_2 } = this.payment_days;

      if (day_2 > 0) {
        for (let i = 3; i <= 7; i++) {
          this.payment_days[`day_${i}`] = 0;
        }
      }
    },
    "payment_days.day_3"() {
      if (!this.settingData) return;
      const { day_3 } = this.payment_days;

      if (day_3 > 0) {
        for (let i = 4; i <= 7; i++) {
          this.payment_days[`day_${i}`] = 0;
        }
      }
    },
    "payment_days.day_4"() {
      if (!this.settingData) return;
      const { day_4 } = this.payment_days;

      if (day_4 > 0) {
        for (let i = 5; i <= 7; i++) {
          this.payment_days[`day_${i}`] = 0;
        }
      }
    },
    "payment_days.day_5"() {
      if (!this.settingData) return;
      const { day_5 } = this.payment_days;

      if (day_5 > 0) {
        for (let i = 6; i <= 7; i++) {
          this.payment_days[`day_${i}`] = 0;
        }
      }
    },
    "payment_days.day_6"() {
      if (!this.settingData) return;
      const { day_6 } = this.payment_days;

      if (day_6 > 0) {
        this.payment_days.day_7 = 0;
      }
    }
  },
  methods: {
    ...mapActions({
      updateAddon: "addons/updateAddon",
      getOrganizationAddons: "organization/getOrganizationAddons"
    }),
    // updateSelector(val) {
    //   switch(val.id) {
    //     case 1:
    //       this.payload.json_config.retry_days_in_month = val.value
    //       break
    //     case 2:
    //       this.payload.json_config.retry_month = val.value
    //       break
    //   }
    // },
    // updateDate(val) {
    //   console.log(val);
    //   switch(val.id) {
    //     case 1:
    //       this.payload.json_config.day_one = val.day
    //       break
    //     case 2:
    //       this.payload.json_config.day_two = val.day
    //       break
    //     case 3:
    //       this.payload.json_config.day_three = val.day
    //       break
    //     case 4:
    //       this.payload.json_config.day_four = val.day
    //       break
    //     case 5:
    //       this.payload.json_config.day_five = val.day
    //       break
    //   }
    // },

    async setLocalData() {
      await this.getOrganizationAddons(this.orgId);

      const engineSubscriptionAddon = this.organizationAddons.find(
        e => e.name === "Engine Subscriptions"
      );
      if (engineSubscriptionAddon) {
        const {
          json_config: {
            day_1,
            day_2,
            day_3,
            day_4,
            day_5,
            day_6,
            day_7,
            retry_days_in_month,
            retry_days_between_dates,
            retry_month
          }
        } = engineSubscriptionAddon;

        this.payload = {
          addon_id: 2,
          json_config: {
            day_1,
            day_2,
            day_3,
            day_4,
            day_5,
            day_6,
            day_7,
            retry_days_in_month,
            retry_days_between_dates,
            retry_month
          },
          status: true
        };
        this.payment_days = {
          day_1,
          day_2,
          day_3,
          day_4,
          day_5,
          day_6,
          day_7
        };
        this.generatePaymentDays();
      } else {
        this.cleanData();
      }
    },
    async submitInit() {
      const { payload } = this;

      payload.status = true;

      this.setDefaultValues();

      this.initModal = false;
    },
    async submit(isInit) {
      const { payload, updateAddon, setLocalData, payment_days, orgId } = this;

      payload.orgId = orgId;

      const { day_1, day_2, day_3, day_4, day_5, day_6, day_7 } = payment_days;

      this.payload.json_config.day_1 = day_1;
      this.payload.json_config.day_2 = day_2;
      this.payload.json_config.day_3 = day_3;

      if (day_1 === 0 || day_2 === 0 || day_3 === 0) {
        this.$toast.error(this.$t("organization.config_recurrences.error.min"));
        return;
      }

      this.payload.json_config.day_4 = day_4;
      this.payload.json_config.day_5 = day_5;
      this.payload.json_config.day_6 = day_6;
      this.payload.json_config.day_7 = day_7;

      if (isInit) {
        payload.status = true;
      }
      await updateAddon(payload);
      if (!isInit) {
        this.successModal = true;
      }
      setLocalData();
      if (isInit) {
        this.initModal = false;
      }
    },
    cleanData() {
      this.loading = false;
      this.payload = {
        addon_id: 2,
        json_config: {
          retry_days_in_month: 0,
          retry_days_between_dates: 0,
          retry_month: 0,
          day_one: 0,
          day_two: 0,
          day_three: 0,
          day_four: 0,
          day_five: 0,
          day_six: 0,
          day_seven: 0
        },
        status: false
      };
    },
    handleRetryDaysInMonth() {
      const {
        retry_days_between_dates,
        retry_days_in_month
      } = this.payload.json_config;

      if (retry_days_between_dates > retry_days_in_month) {
        this.payload.json_config.retry_days_in_month = retry_days_between_dates;
      }
    },
    isAllowedRetryPerMonth(item) {
      const { retry_days_between_dates } = this.payload.json_config;
      return item < retry_days_between_dates;
    },
    isAllowedPaymentDay(item, index) {
      const lastDayValue = this.payment_days[`day_${index - 1}`];

      return item <= lastDayValue;
    },
    addNewDate() {
      const { timeLineItems, payment_days } = this;

      if (timeLineItems.length - 1 <= Object.values(payment_days).length) {
        timeLineItems.push({
          icon: "mdi-calendar"
        });
      } else {
        this.$toast.show(this.$t("organization.config_recurrences.error.max"), {
          type: "error",
          position: "top-right",
          duration: 3000
        });
      }
    },
    deleteNewDate(index) {
      const { timeLineItems } = this;

      timeLineItems.pop();
      this.payment_days[`day_${index}`] = 0;
    },
    retryDaysMessage(index) {
      const { retry_days_between_dates } = this.payload.json_config;
      let retryDaysString = "";

      for (let i = 1; i <= retry_days_between_dates; i++) {
        if (this.payment_days[`day_${index}`] + i === 28) {
          retryDaysString += `${this.payment_days[`day_${index}`] + i}`;
          break;
        } else if (i !== retry_days_between_dates) {
          retryDaysString += `${this.payment_days[`day_${index}`] + i}, `;
        } else {
          retryDaysString += `${this.payment_days[`day_${index}`] + i}`;
        }
      }

      return retryDaysString;
    },
    mapPaymentDay(index) {
      switch (index) {
        case 1:
          return "Primer";
        case 2:
          return "Segundo";
        case 3:
          return "Tercer";
        case 4:
          return "Cuarto";
        case 5:
          return "Quinto";
        case 6:
          return "Sexto";
        case 7:
          return "Séptimo";
        default:
          break;
      }
    },
    generatePaymentDays() {
      const { payment_days, timeLineItems } = this;
      const { day_4, day_5, day_6, day_7 } = payment_days;

      if (timeLineItems.length - 1 === 3) {
        if (day_4 > 0) {
          this.timeLineItems.push({
            icon: "mdi-calendar"
          });
        }
        if (day_5 > 0) {
          this.timeLineItems.push({
            icon: "mdi-calendar"
          });
        }
        if (day_6 > 0) {
          this.timeLineItems.push({
            icon: "mdi-calendar"
          });
        }
        if (day_7 > 0) {
          this.timeLineItems.push({
            icon: "mdi-calendar"
          });
        }
      }
    },
    async setDefaultValues() {
      const { payload, orgId } = this;

      payload.orgId = orgId;

      payload.json_config.day_1 = 1;
      payload.json_config.day_2 = 10;
      payload.json_config.day_3 = 15;
      payload.json_config.retry_days_in_month = 3;
      payload.json_config.retry_days_between_dates = 1;
      payload.json_config.retry_month = 5;

      await this.updateAddon(payload);
      this.setLocalData();
    }
  }
};
</script>

<style scoped>
.select {
  width: 80px;
}
.select-day {
  width: 100px;
}
.v-timeline::before {
  top: 55px;
  height: calc(100% - 110px);
}
</style>
